/**
 *Created by jmmartinez on 05/05/19
 * v.1.1 04/11/2019 Añadida opción: Último mes.
 * v.1.2 05/06/2020 Añadidas propiedades campoClave y campoTexto
 * v.1.3 03/07/2020 Modificado getOpcionFromValor para usar en la llamada a filtrarConNombreCampo usamos fieldKey
 * v.2.0 30/09/2020 Cambiado a framework2
 * v.2.1 28/10/2020 En el método getOpcionFromValor, comprobamos si hay un valor definido.
 *                  Creado un nuevo método renderComboBox
 *                  Añadida propiedad Inline para poner el título en linea o arriba.
 *                  Utilización de css del archivo selectoropciones.css
 * v.2.2 22/11/2020 Añadida propiedad campoClave2, para proporionar un segundo valor del objeto al seleccionarlo.
 *                  Modificado onValuehanged para devolver este valor en el evento onValueChanged
 * v.2.3 16/07/2021 Añadida propiedad ValorInicial
 * v.2.4 03/02/2023 En getOpcionValor, cambiado "if (valor)" por "if (valor != null)", porque si no no distingue el valor 0 y lo toma como null.
 *                  En getDerivedStateFromProps, cambiado "nextProps.valor && nextProps.valor !== prevState.valor" por
 *                          "nextProps.valor != null && nextProps.valor != prevState.valor"
 *                          porque al comparar 0 y null no entra.
 * v.2.5 05/09/2023 Modificado el import para usar el ComboBox de /ej2/UI
 *                  Modificado el método Render para utilizar el label como título
 * */


import React from 'react'
import PropTypes from 'prop-types';
import {FormGroup} from "@blueprintjs/core";
//import ComboBox from "../../blueprint/ComboBox";
import ComboBox from "./ComboBox";
import {filtrarConNombreCampo} from "../utils/FilterUtils"
import "../../resources/css/selectoropciones.css";

//Esperamos una lista de opciones con la estructura:
//[{valor: 0, nombre: 'A'}, {valor: 1, nombre: 'B'}]

class SelectorOpciones extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            opciones: props.opciones,
            //valor: props.valorInicial ? props.valorInicial : -1,
            valor:  props.valorInicial,
            campoClave: props.campoClave,
            campoClave2: props.campoClave2,
            campoTexto: props.campoTexto,
        }
        console.log("SelectorOpciones - Constructor");
        console.log("props.opciones: ", props.opciones);
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        /*
        console.log("Selector opciones - getDerivedStateFromProps");
        console.log("nextProps.opciones: ", nextProps.opciones);
        console.log("prevState.opciones: ", prevState.opciones);
        */

        if (nextProps.opciones && nextProps.opciones !== prevState.opciones) {
            newState.opciones = nextProps.opciones;
        }
        if (nextProps.valor != null &&  nextProps.valor != prevState.valor) {
            newState.valor = nextProps.valor;
            //console.log("<><>nuevoValor: ", newState.valor);
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onValueChanged= (newObject) => {
        const {valor} = this.state;
        const {onValueChanged, campoClave, campoClave2} = this.props;
        let fieldKey= campoClave ? campoClave : "valor";
        let fieldKey2= campoClave2 ? campoClave2 : "";
        let newValor= newObject[fieldKey];
        let newValor2= fieldKey2 !== "" ? newObject[fieldKey2] : "";

        /*
        console.log("SELECTOROPCIONES - onValueChanged");
        console.log("newObject: ", newObject);
        console.log("fieldKey: ", fieldKey);
        console.log("fieldKey2: ", fieldKey2);
        console.log("valor: ", valor);
        console.log("newValor:",  newValor);
        console.log("newValor2:",  newValor2);
        */
        if (valor != newValor){
            console.log("dentro");
            this.setState({valor: newValor}, () => {
                onValueChanged && onValueChanged(newValor, newValor2);
                });
        }

    }

    getOpcionFromValor= (valor) => {
        const {opciones} = this.state;
        const {campoClave} = this.props;

        /*
        console.log("SELECTOROPCIONES - getOpcionFromValor");
        console.log("valor", valor);
        console.log("opciones: ", opciones);
        console.log("campoClave: ", campoClave);
        */

        if (valor != null) {
            //console.log("dentro");
            let fieldKey = campoClave ? campoClave : "valor";
            let opcionesFiltradas = filtrarConNombreCampo(opciones, fieldKey, valor);
            if (opcionesFiltradas && opcionesFiltradas.length > 0)
                return opcionesFiltradas[0];
            else
                return null;
        }
        else
            return null;
    }

    render= () => {
        const {valor, opciones} = this.state;
        const {id, icon, titulo, campoClave, campoTexto, inline} = this.props;
        let opcionSeleccionada= this.getOpcionFromValor(valor);

        /*
        console.log("selectorOpcions - RENDER");
        console.log("valor: " + valor);
        console.log("opciones: " + opciones);
        console.log("opcionSeleccionada: ", opcionSeleccionada);
        */

        return <ComboBox
            id={id}
            icon= "wrench"
            fieldText= {campoTexto ? campoTexto : "nombre"}
            fieldKey= {campoClave ? campoClave : "valor"}
            items={opciones}
            onValueChanged={(objeto) => this.onValueChanged(objeto)}
            placeholder= "Opciones"
            filterable={false}
            itemSelected= {opcionSeleccionada}
            label={titulo}
            labelInline={inline}
        />
    }



}


SelectorOpciones.propTypes = {
    id: PropTypes.string,
    opciones: PropTypes.array.isRequired,
    titulo: PropTypes.string,
    inline: PropTypes.bool,
    valor: PropTypes.number,
    icon: PropTypes.string,
    onValueChanged: PropTypes.func,
    campoClave: PropTypes.string,
    campoTexto: PropTypes.string,
    valorInicial: PropTypes.number,
}

export default SelectorOpciones

